import { __assign, __extends, __rest } from "tslib";
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import React from 'react';
import { ReviewsSortBy } from '../../../../../enums/marketplace-enums';
import { DropdownBase, TextButton } from 'wix-style-react';
import { composer } from '../../../../../component-decorators/composer';
export var SortDropDown = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, props = __rest(_a, ["t"]);
    return (React.createElement(SortDropDownComponent, __assign({ t: t }, props)));
});
var SortDropDownComponent = /** @class */ (function (_super) {
    __extends(SortDropDownComponent, _super);
    function SortDropDownComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onSelectHandler = function (selectedOption) {
            if (selectedOption &&
                selectedOption.value !== _this.state.currentSortMethod) {
                _this.setState({ currentSortMethod: selectedOption.id });
                _this.props.sortBy(selectedOption.id);
            }
        };
        _this.state = {
            currentSortMethod: _this.props.t('solution.page.reviewsBtnRecent'),
        };
        _this.onSelectHandler = _this.onSelectHandler.bind(_this);
        return _this;
    }
    SortDropDownComponent.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { style: { textAlign: this.props.isMobile ? 'left' : 'center' } },
            React.createElement(DropdownBase, { dataHook: "drop-down-base", onSelect: this.onSelectHandler, initialSelectedId: ReviewsSortBy.MostRecent, options: [
                    {
                        id: ReviewsSortBy.MostRecent,
                        value: this.props.t('solution.page.reviewsBtnRecent'),
                    },
                    {
                        id: ReviewsSortBy.MostHelpful,
                        value: this.props.t('solution.page.reviewsBtnHelpful'),
                    },
                    {
                        id: ReviewsSortBy.Rating,
                        value: this.props.t('solution.page.reviewsBtnRating'),
                    },
                ] }, function (_a) {
                var toggle = _a.toggle, selectedOption = _a.selectedOption;
                return (React.createElement(TextButton, { skin: "dark", weight: "normal", onClick: toggle, suffixIcon: React.createElement(ChevronDown, null), priority: "secondary", dataHook: "sort-drop-down-btn", size: "medium" }, (selectedOption && selectedOption.value) ||
                    _this.state.currentSortMethod));
            })));
    };
    return SortDropDownComponent;
}(React.Component));
//# sourceMappingURL=sort-dropdown.js.map